import { Injectable } from '@angular/core';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { Store } from '@ngrx/store';
import { undefinedOrSwitchMap } from 'src/util/rxjs';
import { BehaviorSubject, isObservable, map, Observable, of, switchMap } from 'rxjs';
import { AppState } from 'src/store/appstate';
import { observeCommunicationCenterFromRouteNavigationEnd } from 'src/models/communication-center-view-model';
import { RouterService } from 'src/app/shared/shared-base/amg-ui/router.service';
import { OpsReaderAuthorizationService } from '../tcs-authorization/ops-reader-authorization.service';

@Injectable({
  providedIn: 'root',
})
export class OpsReadonlyService {
  private _isReadonly$ = new BehaviorSubject<boolean>(false);

  public get hasReadonlyAccess() {
    return this._isReadonly$.getValue();
  }

  public get hasReadonlyAccess$() {
    return this._isReadonly$.asObservable();
  }

  constructor(
    tcsConfig: TcsConfigurationService,
    opsReader: OpsReaderAuthorizationService,
    store: Store<AppState>,
    router: RouterService,
  ) {
    observeCommunicationCenterFromRouteNavigationEnd(router, store, 'all')
      .pipe(
        undefinedOrSwitchMap((commCenter) =>
          opsReader.isReadonlyForCommCenterAndCurrentCompany(commCenter.id),
        ),
        map((isReadonly) => tcsConfig.value.features.opsReaderEnabled && (isReadonly ?? false)),
      )
      .subscribe(this._isReadonly$);
  }

  public readonlyOverride(
    value: boolean | Observable<boolean>,
    expect: boolean = true,
  ): Observable<boolean> {
    return this.hasReadonlyAccess$.pipe(
      switchMap((isReadonly) => {
        if (isReadonly) {
          return of(!expect);
        }
        return isObservable(value) ? value : of(value);
      }),
    );
  }
}
